<div class="noprint h-150 table-container-th">
	<div
		class="card p-0 m-0"
		*ngFor="
			let year of this.data | keyvalue : reverseKeyOrder;
			let yearIndex = index
		"
	>
		<h3 class="text-center">
			<span class="text-black">{{ year.key }}</span>
		</h3>

		<div class="m-0 p-0">
			<div
				class=""
				*ngFor="let node of this.data[year.key]; let testResultIndex = index"
			>
				<table class="table m-0 py-2 table-fixed">
					<thead>
						<tr class="bg-{{ node.assessmentBookId }}">
							<td colspan="3">
								<span class=""> {{ node.testDate }}</span>
								<span class="text-muted font-weight-light">
									{{ phaseTitle(node.assessmentBookId) }}</span
								>
							</td>
						</tr>
					</thead>

					<tr *ngFor="let eachQuestion of node.scoredQuestions; let i = index">
						<ng-container *ngIf="eachQuestion.type == scoreType.PROGRESS">
							<td class=" bg-{{ eachQuestion.testId }}">
								<span class="font-weight-bold">{{ eachQuestion.label }}</span>
								<div
									class="text-muted"
									style="font-size: 12px"
									*ngIf="!rsp.media.is_mobile"
								>
									{{ eachQuestion.question }}
								</div>
							</td>
							<td width="50px">
								<div class="h4">
									<div class="text-center badge badge-secondary ng-binding">
										{{ eachQuestion.latestScore }}
									</div>
								</div>
							</td>
							<td width="50px" *ngIf="canDelete()">
								<div class="h5">
									<div
										class="text-center badge badge-secondary ng-binding"
									></div>

									<div *ngIf="eachQuestion.edit; else elseBlock">
										<div *ngIf="testResultIndex == 0; else showDefault">
											<span
												class="fa fa-trash-o btn  btn-outline-danger"
												[ngbPopover]="alertContent"
												popoverTitle=" Delete Score?"
												placement="left"
											></span>
										</div>
										<ng-template #showDefault>
											<span
												class="fa fa-trash-o btn  btn-outline-danger "
												ngbPopover="To delete this placement score, all subsequent scores must first be removed."
												placement="left"
											></span>
										</ng-template>
									</div>
									<ng-template #elseBlock> </ng-template>
								</div>
								<ng-template #alertContent>
									<div class="d-flex justify-content-center">
										<button
											type="button"
											(click)="deleteThisScore(eachQuestion.testScoreId)"
											class="btn btn btn-success btn-md"
										>
											<i class="fa fa-check-circle-o" aria-hidden="true"></i
											>&nbsp;Yes</button
										>&nbsp;&nbsp;
										<button type="button" class="btn btn btn-danger btn-md">
											<i class="fa fa-ban" aria-hidden="true"></i>&nbsp;No
										</button>
									</div>
								</ng-template>
							</td>
						</ng-container>
					</tr>
				</table>
			</div>
		</div>
	</div>
</div>
<div
	class="card p-0 m-0 print"
	*ngFor="let year of this.data | keyvalue : reverseKeyOrder; let i = index"
>
	<h4 class="text-center">
		<span class="text-black">{{ year.key }}</span>
	</h4>

	<div class="m-0 p-0 print">
		<table
			class="table table-responsive print"
			*ngFor="let node of this.data[year.key]; let i = index"
		>
			<tr style="text-align: left">
				<td colspan="3" style="padding-top: 3em; border-top: none">
					<p class="marging-top:20px" style="text-align: left">
						Assessed: {{ node.testDate }}
					</p>
				</td>
			</tr>

			<tr style="text-align: left">
				<td><strong>Challenge</strong></td>
				<td><strong>Description</strong></td>
				<td><strong>Score</strong></td>
			</tr>

			<tr *ngFor="let eachQuestion of node.scoredQuestions; let i = index">
				<td>{{ eachQuestion.label }}</td>
				<td>
					<span *ngIf="!rsp.media.is_mobile">{{ eachQuestion.question }}</span>
				</td>

				<td width="50px">
					<div>
						<div class="text-center">{{ eachQuestion.latestScore }}</div>
					</div>
				</td>
			</tr>
		</table>
	</div>
</div>
